/**
 * Created by razial on 10.06.2025.
 */

const Spawner = function (unit, options) {
    UnitComponent.call(this, unit);

    this.time = options.time || 0;
    this.prizes = 0;
    this.speedups = 0;
    this.noSpace = false;

    this.updateState();

    Map2d.currentMap.on("onUnitAvailable", this.planUpdate.bind(this), this);
    Map2d.currentMap.on("onUnitRemoved", this.planUpdate.bind(this), this);
};

Spawner.prototype = Object.create(UnitComponent.prototype);
Spawner.prototype.constructor = Spawner;

Spawner.prototype.save = function (data) {
    data.time = this.time || undefined;
};

Spawner.prototype.destructor = function () {
    clearTimeout(this.timeout);

    runCleaners(this);
};

Spawner.prototype.planUpdate = function () {
    if (!Map2dLocation.currentLocation.needSpawnerUpdate) {
        Map2dLocation.currentLocation.needSpawnerUpdate = true;
        Map2dLocation.currentLocation.counter.trigger(1);
    }
};

Spawner.prototype.updateState = function () {
    this.planUpdate();

    clearTimeout(this.timeout);

    const timeLeft = this.getTimeLeft();
    if (timeLeft) {
        this.timeout = new cleverapps.LongTimeout(this.updateState.bind(this), timeLeft);
    }

    if (this.prizes) {
        if (!this.unit.prizes) {
            this.unit.setPrizes({ sprite: bundles.merge.frames.prize_exclamation });
        }
    } else {
        this.unit.setPrizes(undefined);
    }

    if (this.view) {
        this.view.restoreState(true);
    }
};

Spawner.prototype.handlePrizes = function () {
    const config = Spawner.PRIZES[cleverapps.meta.selectedLocationId()];
    if (!config) {
        return;
    }

    const prizes = [];

    for (const prize of config) {
        for (let i = prize.weight || 1; i > 0; --i) {
            prizes.push({
                code: prize.code,
                stage: prize.stage,
                grounded: 0
            });
        }
    }

    const pseudo = PseudoRandom.GET("secondary");
    pseudo.seed(this.time);

    const selected = [];

    for (let i = 0; i < this.prizes; ++i) {
        selected.push(pseudo.choose(prizes));
    }
    
    const ux = this.unit.x;
    const uy = this.unit.y;
    const expand = 2;

    const area = [];
    const spawnerRegionCells = Map2d.currentMap.regions.spawner_cells;
    if (spawnerRegionCells && spawnerRegionCells.positions && spawnerRegionCells.positions.length > 0) {
        spawnerRegionCells.positions.forEach((position) => {
            area.push({ x: position.x, y: position.y });
        });
    } else {
        let minX = ux, maxX = ux, minY = uy, maxY = uy;
        this.unit.getShape().forEach((part) => {
            minX = Math.min(minX, ux + part.x);
            maxX = Math.max(maxX, ux + part.x);
            minY = Math.min(minY, uy + part.y);
            maxY = Math.max(maxY, uy + part.y);
        });
        for (let ay = minY - expand; ay <= maxY + expand; ay++) {
            for (let ax = minX - expand; ax <= maxX + expand; ax++) {
                area.push({ x: ax, y: ay });
            }
        }
    }

    const remains = Map2dLocation.currentLocation.spawn(selected, this.unit, { area, effect: "merge.spawn.spawner", spawnSource: "spawner" });

    this.prizes = remains.length;
    this.time += Spawner.RECHARGING_TIME * (selected.length - remains.length);
    this.noSpace = remains.length > 0;

    this.unit.save();

    this.updateState();

    return true;
};

Spawner.prototype.handleClick = function () {
    if (this.noSpace) {
        return false;
    }

    if (this.getTimeLeft() && this.canSpeedUp()) {
        cleverapps.focusManager.display({
            focus: "SpeedUpSpawner",
            action: (f) => {
                new ConfirmSpeedUpWindow(this.getSpeedUpOptions());
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    } else {
        cleverapps.centerHint.createTextHint(Messages.get("Spawner.Idle"));
    }
    return true;
};

Spawner.prototype.getSpeedUpOptions = function () {
    return {
        timeLeft: this.getTimeLeft(),
        totalDuration: Spawner.RECHARGING_TIME,
        eventName: cleverapps.EVENTS.SPENT.SPAWNER,
        callback: this.speedUpCharging.bind(this)
    };
};

Spawner.prototype.getTimeLeft = function () {
    return Math.max(0, this.time + this.prizes * Spawner.RECHARGING_TIME - Date.now());
};

Spawner.prototype.startRecharging = function () {
    if (!this.time) {
        this.time = Date.now();
        this.unit.save();

        this.updateState();
    }
};

Spawner.prototype.stopRecharging = function () {
    if (this.time) {
        this.time = 0;
        this.noSpace = false;
        this.unit.save();

        this.updateState();
    }
};

Spawner.prototype.countPrizes = function () {
    return this.prizes;
};

Spawner.prototype.canSpawn = function () {
    return this.countPrizes() < Spawner.BATCH_SIZE && this.time && this.getTimeLeft() === 0;
};

Spawner.prototype.addPrize = function () {
    this.prizes += 1;

    this.updateState();
};

Spawner.prototype.speedUpCharging = function () {
    if (this.canSpeedUp()) {
        this.prizes = 1;
        this.time = Date.now();
        this.handlePrizes();
        ++this.speedups;
    }
};

Spawner.prototype.canSpeedUp = function () {
    return this.speedups < Spawner.BATCH_SIZE && !this.noSpace;
};

Spawner.prototype.resetSpeedUp = function () {
    this.speedups = 0;
};

Spawner.PRIZES = {};

Spawner.RECHARGING_TIME = cleverapps.parseInterval("10 minutes");
Spawner.BATCH_SIZE = 5;
Spawner.UPPER_MAP_FILL_RATE = 0.4;
Spawner.LOWER_MAP_FILL_RATE = 0.2;

Spawner.getSpawners = function () {
    let free = 0, occupied = 0;

    const spawners = [];

    Map2d.currentMap.listAvailableGrounds().forEach((ground) => {
        free += 1;

        const unit = Map2d.currentMap.getUnit(ground.x, ground.y);
        if (unit) {
            occupied += 1;

            const spawner = unit.findComponent(Spawner);
            if (spawner) {
                spawners.push(spawner);

                occupied += spawner.countPrizes();
            }
        }
    });
    return {
        spawners,
        free,
        occupied
    };
};

Spawner.processUpdate = function () {
    if (!Map2dLocation.currentLocation.needSpawnerUpdate) {
        return;
    }

    Map2dLocation.currentLocation.needSpawnerUpdate = false;

    // eslint-disable-next-line prefer-const
    let { spawners, free, occupied } = Spawner.getSpawners();

    const upperBound = Math.floor(free * Spawner.UPPER_MAP_FILL_RATE);
    const lowerBound = Math.floor(free * Spawner.LOWER_MAP_FILL_RATE);

    spawners = PseudoRandom.GET().shuffle(spawners);

    for (const spawner of spawners) {
        while (occupied < upperBound && spawner.canSpawn()) {
            spawner.addPrize();

            occupied += 1;
        }
    }

    if (occupied < lowerBound) {
        spawners.forEach((spawner) => spawner.startRecharging());
    }

    if (occupied >= upperBound) {
        spawners.forEach((spawner) => spawner.stopRecharging());
    }

    if (occupied < upperBound) {
        spawners.forEach((spawner) => spawner.resetSpeedUp());
    }

    const tutorial = cleverapps.tutorial.findScenario(AdvSpawnerTutorial.NAME);
    if (tutorial && tutorial.isAvailable() && spawners.some((spawner) => spawner.getTimeLeft())) {
        cleverapps.tutorial.startScenario(tutorial);
    }
};
